import { render, staticRenderFns } from "./SafetyYujingDialog.vue?vue&type=template&id=79279a2c&scoped=true&"
import script from "./SafetyYujingDialog.vue?vue&type=script&lang=js&"
export * from "./SafetyYujingDialog.vue?vue&type=script&lang=js&"
import style0 from "./SafetyYujingDialog.vue?vue&type=style&index=0&id=79279a2c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79279a2c",
  null
  
)

export default component.exports